import React, { useEffect, useState } from "react";
import Header from "../../Components/Header/Header";
import Footer from "../../Components/Footer/Footer";
import { APIUrl, APIUrlToken, getIsUser } from "../../Utils/Utils";
import axios from "axios";
import Loader from "../../Components/Loader/Loader";
import moment from "moment";
import "../AthleteDashboard/AdminDashboard.css";
import AthletePricingDashboard from "./AthletePricingDashboard";

const AthleteDashboard = () => {
  const userData = getIsUser();
  const [activeMainTab, setActiveMainTab] = useState("dashboard");
  const [activePricingTab, setActivePricingTab] = useState("fan");
  const [transactions, setTransactions] = useState([]);
  const [totalAmount, setTotalAmount] = useState(0);
  const [loading, setLoading] = useState(true);

  // Fetch athlete transactions
  useEffect(() => {
    if (!userData?.player_id) return;
    const fetchTransactions = async () => {
      try {
        const res = await axios.get(`${APIUrl()}/v1/transactions/by_player`, {
          headers: {
            "X-API-Key": APIUrlToken(),
          },
          params: {
            player_id: userData.player_id,
          },
        });

        setTransactions(res.data.transactions || []);
        setTotalAmount(res.data.total_amount || 0);
      } catch (error) {
        console.error("Failed to fetch player transactions", error);
      } finally {
        setLoading(false);
      }
    };
    fetchTransactions();
  }, [userData?.player_id]);

  return (
    <div>
      {loading && <Loader />}
      <Header />
      <div className="admin-dashboard-container">
        <h2 className="admin-dashboard-title">Athlete Dashboard</h2>

        {/* Main Tabs */}
        <div className="admin-tabs">
          <div
            className={`admin-tab ${
              activeMainTab === "dashboard" ? "active" : ""
            }`}
            onClick={() => setActiveMainTab("dashboard")}
          >
            Athlete Dashboard
          </div>
          <div
            className={`admin-tab-pricing ${
              activeMainTab === "pricing" ? "active" : ""
            }`}
            onClick={() => setActiveMainTab("pricing")}
          >
            Pricing
          </div>
        </div>

        {/* Panel Content */}
        <div className="admin-panel-content">
          {activeMainTab === "dashboard" && (
            <div className="admin-dashboard-section">
              {transactions.length > 0 ? (
                <>
                  <table className="admin-table">
                    <thead>
                      <tr>
                        <th>S.No</th>
                        <th>Transaction Amount</th>
                        <th>Transaction Type</th>
                        <th>Payment Method</th>
                        {/* <th>Recurring Duration</th> */}
                        <th>Date Received</th>
                      </tr>
                    </thead>
                    <tbody>
                      {transactions.map((txn, index) => (
                        <tr key={txn.transaction_id}>
                          <td>{index + 1}</td>
                          <td>${txn.transaction_amount}</td>
                          <td>{txn.transaction_type || "-"}</td>
                          <td>{txn.payment_method_type || "-"}</td>
                          {/* <td>
                            {txn.recurring_cost_duration > 0
                              ? `${txn.recurring_cost_duration} months`
                              : "-"}
                          </td> */}
                          <td>
                            {txn.created_at
                              ? moment(txn.created_at).format("MM/DD/YYYY")
                              : "-"}
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                  <div className="admin-total-row">
                    Total: ${totalAmount}
                  </div>
                </>
              ) : (
                <div className="admin-no-results">No Transactions Found</div>
              )}
            </div>
          )}

          <AthletePricingDashboard
            activeMainTab={activeMainTab}
            activePricingTab={activePricingTab}
            setActivePricingTab={setActivePricingTab}
            userData={userData}
          />
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default AthleteDashboard;

// import React, { useEffect, useState } from 'react';
// import Header from '../../Components/Header/Header';
// import Footer from '../../Components/Footer/Footer';
// import { APIUrl, APIUrlToken, getIsUser } from '../../Utils/Utils';
// import axios from 'axios';
// import Loader from '../../Components/Loader/Loader';
// import moment from 'moment';
// import "../AthleteDashboard/AdminDashboard.css";

// const AthleteDashboard = () => {
//   const userData = getIsUser();
//   const [transactions, setTransactions] = useState([]);
//   const [totalAmount, setTotalAmount] = useState(0);
//   const [loading, setLoading] = useState(true);

//   useEffect(() => {
//     if (!userData?.player_id) return;
//     const fetchTransactions = async () => {
//       try {
//         const res = await axios.get(
//               `${APIUrl()}/v1/transactions/by_player`,
//               {
//                 headers: {
//                   'X-API-Key': APIUrlToken(),
//                 },
//                 params: {
//                   player_id: userData.player_id,
//                 }
//               }
//             );

//         setTransactions(res.data.transactions || []);
//         setTotalAmount(res.data.total_amount || 0);
//       } catch (error) {
//         console.error("Failed to fetch player transactions", error);
//       } finally {
//         setLoading(false);
//       }
//     };
//     fetchTransactions();
//   }, [userData?.player_id]);

//   return (
//     <div>
//       {loading && <Loader />}
//       <Header />
//       <div className='page-main-container-aboutus'>
//         <div className="heading-button">
//           <div className="tophead-head">
//             <h2 className='icons-all-list-mmbr-new'>Athlete Dashboard</h2>
//           </div>

//           <div className="dataTables_scrollBody">
//             {
//               transactions.length > 0 ? (
//                 <>
//                   <table id="table_id" className="table table-striped dataTable no-footer user_table_nil">
//                     <thead className='table-head-ad-dash-playesinfo'>
//                       <tr>
//                         <th>S.No</th>
//                         <th>Transaction Amount</th>
//                         <th>Transaction Type</th>
//                         <th>Payment Method</th>
//                         <th>Recurring Duration</th>
//                         <th>Contribution Received On</th>
//                       </tr>
//                     </thead>
//                     <tbody className='table-body-ad-dash-playesinfo'>
//                       {transactions.map((txn, index) => (
//                         <tr key={txn.transaction_id}>
//                           <td>{index + 1}</td>
//                           <td>${txn.transaction_amount}</td>
//                           <td>{txn.transaction_type || '-'}</td>
//                           <td>{txn.payment_method_type || '-'}</td>
//                           <td>{txn.recurring_cost_duration > 0 ? `${txn.recurring_cost_duration} months` : '-'}</td>
//                           <td>{txn.created_at ? moment(txn.created_at).format("MM/DD/YYYY") : '-'}</td>
//                         </tr>
//                       ))}
//                     </tbody>
//                   </table>
//                   <div className="admin-total-row" style={{ textAlign: 'right', padding: '10px 20px', fontWeight: 'bold' }}>
//                     Total Contributions Received: ${totalAmount}
//                   </div>
//                 </>
//               ) : (
//                 <div className="no_results">No Transactions Found</div>
//               )
//             }
//           </div>
//         </div>
//       </div>
//       <Footer />
//     </div>
//   );
// };

// export default AthleteDashboard;
